import Footer from "components/Footer";
import Header from "components/Header";
import { useEffect, useState } from "react";
import MainTitle from "components/MainTitle";
import QuickDonate from "components/QuickDonate/QuickDonate";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import { RootState } from "redux/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { getOrphansListActions } from "redux/actions/OrphansSponsorshipActions/getOrphansListActions";
import { Spin } from "antd";
import { useTranslation } from "react-i18next";
import MaleCard from "./MaleCard";
import FemaleCard from "./FemaleCard";

const OrphanSponsorship = () => {
  const { t, i18n } = useTranslation();
  const [selectedGender, setSelectedGender] = useState("male");

  const dispatch: any = useDispatch();

  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );

  useEffect(() => {
    dispatch(getOrphansListActions(selectedGender));
  }, [dispatch, selectedGender]);

  const { orphanList, orphanListLoading } = useSelector(
    (state: RootState) => state.getOrphanListReducer
  );

  return (
    <>
      <Header />

      <main className="relative w-full">
        {/* quick donate *******************************/}
        <QuickDonate />

        {/* quick donate popup  ************************/}
        {quickDonateStatus && <QuickDonatePopUp />}

        {/* main header section  ***********************/}
        <MainTitle title={t("Orphan Sponsorship")} />

        {/* Orphan Sponsorship Programs section  *******/}
        <section
          data-aos="fade-up"
          data-aos-duration="900"
          className="my-[100px] px-[20px] lg:px-0"
        >
          <div className="mainContainer w-full h-full">
            <div className=" w-full  flex flex-col lg:flex-row lg:items-center gap-12">
              {/* img section */}
              <div className="lg:w-[50%] px-[20px] lg:px-0 h-[244px] lg:h-[380px]">
                <img
                  className="w-full h-full"
                  src="images/internalProjects1.png"
                  alt=""
                />
              </div>

              {/* Orphan Sponsorship details  */}
              <div className="lg:w-[50%] flex flex-col items-center lg:items-start gap-5">
                <p
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[700] text-second_color text-[24px] lg:text-[32px] lg:whitespace-nowrap`}
                >
                  {t("Orphan Sponsorship Programs")}
                </p>

                <p
                  className={`${
                    i18n.language === "en"
                      ? "font-Poppins lg:text-left"
                      : "font-Almarai lg:text-right"
                  } font-[600] text-center text-[14px] lg:text-[16px] max-w-[523px]`}
                >
                  {t(
                    "It is an essential aspect of charitable initiatives that aim to provide financial support and comprehensive care to orphan children to ensure that their basic needs are met and their opportunities in life are enhanced."
                  )}
                </p>

                <p
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[800] text-center lg:text-left text-[14px] lg:text-[16px]`}
                >
                  {t("Our types of sponsorship are:")}
                </p>

                <div className="flex flex-col items-center lg:items-start">
                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[600] text-center lg:text-left text-[14px] lg:text-[16px]`}
                  >
                    {t("Social sponsorship for orphans = 300 AED")}
                  </p>
                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[600] text-center lg:text-left text-[14px] lg:text-[16px]`}
                  >
                    {t("Sponsoring orphans’ tuition fees = 600 AED")}
                  </p>

                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[600] text-center lg:text-left text-[14px] lg:text-[16px]`}
                  >
                    {t("Sponsoring a student’s tuition fees = 600 AED")}
                  </p>
                </div>

                {/* <p
                className={`font-${
                  i18n.language === "en" ? "Poppins" : "Almarai"
                } font-[800] text-center lg:text-left text-[14px] lg:text-[16px]`}
              >
                {t(
                  "The minimum number of months for a monthly warranty is 6 months."
                )}
              </p> */}

                {/* types of sponsorship */}
                <div className="flex flex-col sm:flex-row items-center gap-5">
                  <div className="min-w-[215px] h-[55px] bg-[#EFE5DB] rounded-[80px] flex items-center justify-center">
                    <p
                      className={`font-${
                        i18n.language === "en"
                          ? "Poppins text-[24px]"
                          : "Almarai text-[16px]"
                      } font-[600] text-first_color`}
                    >
                      300 {t("AED")}{" "}
                      <span
                        className={`font-${
                          i18n.language === "en" ? "Poppins" : "Almarai"
                        } font-[400] text-black text-[16px]`}
                      >
                        /{t("Month")}
                      </span>
                    </p>
                  </div>
                  <div className="min-w-[215px] h-[55px] bg-[#EFE5DB] rounded-[80px] flex items-center justify-center">
                    <p
                      className={`font-${
                        i18n.language === "en"
                          ? "Poppins text-[24px]"
                          : "Almarai text-[16px]"
                      } font-[600] text-first_color`}
                    >
                      3600 {t("AED")}{" "}
                      <span
                        className={`font-${
                          i18n.language === "en" ? "Poppins" : "Almarai"
                        } font-[400] text-black text-[16px]`}
                      >
                        /{t("Year")}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* male or female button section  *************/}
        <section
          data-aos="fade-up"
          data-aos-duration="900"
          className="w-full flex items-center justify-center"
        >
          <div className="w-[240px] h-[40px] p-[3px] border-[2px] border-black rounded-[15px] flex items-center justify-between">
            <div
              onClick={() => setSelectedGender("male")}
              className={
                selectedGender === "male"
                  ? `w-[50%] h-full flex items-center justify-center cursor-pointer bg-[#EFE5DB] rounded-[12px] font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[400] text-[14px] text-[#B07F4A]`
                  : `w-[50%] h-full flex items-center justify-center cursor-pointer  font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[400] text-[14px]`
              }
            >
              {t("Male")}
            </div>
            <div
              onClick={() => setSelectedGender("female")}
              className={
                selectedGender === "female"
                  ? `w-[50%] h-full flex items-center justify-center cursor-pointer bg-[#EFE5DB] rounded-[12px] font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[400] text-[14px] text-[#B07F4A]`
                  : `w-[50%] h-full flex items-center justify-center cursor-pointer  font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[400] text-[14px]`
              }
            >
              {t("Female")}
            </div>
          </div>
        </section>

        {/* people section  ****************************/}
        <Spin spinning={orphanListLoading}>
          <section className="my-[100px] mx-auto w-[85%] lg:px-0">
            <div className="mainContainer w-full h-full">
              {selectedGender === "male" ? (
                // male
                <div className="w-full h-full grid grid-cols-1 md:grid-cols-2 gap-10">
                  {/* person */}

                  {orphanList?.map((orpahn: any, i: number) => {
                    return (
                      <Spin key={i} spinning={orphanListLoading}>
                        <MaleCard data={orpahn} />
                      </Spin>
                    );
                  })}
                </div>
              ) : selectedGender === "female" ? (
                // female
                <div className="w-full h-full grid grid-cols-1 md:grid-cols-2 gap-10">
                  {/* person */}
                  {orphanList?.map((orpahn: any, i: number) => {
                    return (
                      <Spin key={i} spinning={orphanListLoading}>
                        <FemaleCard data={orpahn} />
                      </Spin>
                    );
                  })}
                </div>
              ) : (
                ""
              )}
            </div>
          </section>
        </Spin>
      </main>

      <Footer />
    </>
  );
};

export default OrphanSponsorship;
